import React from "react";
import Header from "../components/Header";
import UserTypeSection from "../sections/authentication/UserTypeSection";


function UserTypePage() {
  return (
    <div className={ClassName.container}>
      <div className="mb-16">
          <Header />
        </div>
     
      <UserTypeSection/>
    </div>
  );
}

export default UserTypePage;

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
